import RegisteredGlobalEvent from "./RegisteredGlobalEvent";
export var GlobalEventStates;
(function (GlobalEventStates) {
    GlobalEventStates[GlobalEventStates["failure"] = 0] = "failure";
    GlobalEventStates[GlobalEventStates["success"] = 1] = "success";
})(GlobalEventStates || (GlobalEventStates = {}));
class GlobalEvent {
    constructor(name) {
        this.name = name;
        this.eventObject = window.document;
        this.successName = `${name}:success`;
        this.failureName = `${name}:failure`;
        this.registeredEvent = new RegisteredGlobalEvent(this.successName, this.failureName, this.eventObject);
    }
    /**
     * Return instance of RegisteredEvent
     */
    // @deprecated
    getRegisteredEvent() {
        return this.registeredEvent;
    }
    /**
     * Dispatch result of event
     * We can subscribe for those results by RegisteredEvent
     * @param data
     * @param state
     */
    dispatch(data, state = GlobalEventStates.success) {
        this.createEvent(state === GlobalEventStates.success ? this.successName : this.failureName, data);
        return this;
    }
    /**
     * Register event, it can be caught by listen function
     * @param data
     */
    register(data) {
        this.createEvent(this.name, data);
        return this;
    }
    /**
     * Listen to registered event
     */
    listen(callback) {
        this.eventObject.addEventListener(this.name, ($event) => {
            callback($event.detail);
        });
        return this;
    }
    createEvent(name, data) {
        this.eventObject.dispatchEvent(new CustomEvent(name, {
            detail: data,
        }));
    }
}
export default GlobalEvent;
//# sourceMappingURL=GlobalEvent.js.map